import * as Lodash from 'lodash';
import { create } from 'zustand';
import { ObjectFuncs } from '../../../foundation/js/object.funcs';

function createCollectionStore<T extends { id: string }>() {
  type State = { items: Record<string, T> };

  const useStore = create<State>((set) => ({
    items: {} as Record<string, T>,
  }));

  const useItem = (id?: string) => {
    return useStore((state) => (state as any).items[id ?? '__no_id__']) as T;
  };

  function getItem(id?: string) {
    return useStore.getState().items[id ?? '__no_id__'] as T;
  }

  function updateItem(id: string, item: Partial<T>) {
    if (!id) {
      return;
    }

    useStore.setState((state: State) => {
      const currentItem = state.items[id] ?? {};

      return {
        items: {
          ...state.items,
          [id]: { ...currentItem, ...item },
        },
      };
    });

    return getItem(id);
  }

  function updateItems(items: Record<string, Partial<T>>) {
    useStore.setState((state: State) => {
      const currentItems = state.items;

      const newItems = Lodash.mapValues(items, (item, key) => ({ ...ObjectFuncs.ensure(currentItems[key]), ...item }) as T);

      return {
        items: {
          ...currentItems,
          ...newItems,
        },
      };
    });
  }

  return {
    useItem,
    getItem,
    updateItem,
    updateItems,
  };
}

export const CollectionStore = {
  create: createCollectionStore,
};
